import {getSerialNumber, getUniqueId} from 'react-native-device-info';
import {useEffect, useState} from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {NativeModules} from 'react-native';

let uniqueIdLocal = '';

export async function getDeviceId() {
  const sn = await getSerialNumber();
  if (sn && sn !== 'unknown') {
    return sn;
  } else {
    try {
      const hzsn = await NativeModules.HzModule.getHzSn();
      console.log(hzsn);
      if (hzsn && hzsn !== '') {
        return hzsn;
      } else {
        console.log('无sn：', await getUniqueId());
        return await getUniqueId();
      }
    } catch (e) {
      console.log('sdkerror -> 无sn：', await getUniqueId());
      return await getUniqueId();
    }
  }
}

export async function getUniqueIdAuto() {
  let uniqueId = uniqueIdLocal;
  if (!uniqueId) {
    uniqueId = await getDeviceId();
    console.log(111, uniqueId);
    uniqueIdLocal = uniqueId;
    await AsyncStorage.setItem('uniqueId', uniqueId);
  }
  return uniqueId;
}

export default function useGetDeviceInfo() {
  const [uniqueId, setUniqueIde] = useState(uniqueIdLocal);
  useEffect(() => {
    getUniqueIdAuto().then(v => {
      if (uniqueId !== v) {
        setUniqueIde(v);
      }
    });
  }, []);
  return {
    uniqueId: 'web',
    getUniqueId: getUniqueIdAuto,
  };
}
